export const isDocumentAPhoto = (document) => {
  if (!document.stored_file || !document.stored_file.mime_type) {
    return false;
  }
  // Chrome and Firefox don't support TIFF
  if (document.stored_file.mime_type === 'image/tiff') {
    return false;
  }
  return document.stored_file.mime_type.startsWith('image');
};

// Chrome cannot draw HEIC. A HEIC photo is one the upload could not convert yet, so it is
// offered as a download instead of a blank image.
const BROWSER_UNRENDERABLE_PHOTO_MIME_TYPES = ['image/heic', 'image/heif'];

export const isDocumentAPhotoTheBrowserCanRender = (document) =>
  isDocumentAPhoto(document) &&
  !BROWSER_UNRENDERABLE_PHOTO_MIME_TYPES.includes(document.stored_file.mime_type.toLowerCase());

export const getProcessedUrl = (media, mediaUrl, thumbnail = false) => {
  const url = new URL(mediaUrl, window.location);
  if (thumbnail) {
    url.searchParams.append('thumbnail', true);
  }
  url.searchParams.append('timestamp', media.datetime_updated); // To reload the <img> after the image data has changed we use this trick to 'change' the url with dummy query

  return url.href;
};

export const extractDisplayNameAndExtensionFromFileName = (fileName) => {
  const lastIndexOfADot = fileName.lastIndexOf('.');
  return {
    displayName: fileName.substring(0, lastIndexOfADot),
    extension: fileName.substring(lastIndexOfADot),
  };
};

// Mixpanel tracking helper functions
export const isDocumentCreatedByAIforMixpanel = (document_extra) => {
  return Boolean(document_extra?.created_by_ai);
};

export const getMixpanelDocumentBaseProperties = (document) => {
  return {
    document_id: document.id,
    document_type: document.type,
    document_name: document.document_name,
    created_by_ai: isDocumentCreatedByAIforMixpanel(document.document_extra),
    creation_date: document.creation_date,
    uploaded_by_user_id: document.uploaded_by_user_id,
  };
};

// Helper function that combines mixpanel attributes with document properties
export const getMixpanelAttributesWithDocument = (mixpanel, claim, document, additionalParams = {}) => {
  return {
    ...mixpanel.getMixpanelAttributes(claim, [], additionalParams),
    ...getMixpanelDocumentBaseProperties(document),
  };
};
